import Accordeo from './accordeo';

class Faq {
  private items: NodeListOf<HTMLElement> | null = null;
  private accordeo: Accordeo | null = null;

  constructor() {
    this.items = document.querySelectorAll('.faq__item');
    this.accordeo = new Accordeo(this.items);
    this.accordeo.onClose = this.onClose;
    this.accordeo.onOpen = this.onOpen;
    this.init();
  }

  onOpen(item: HTMLElement) {
    const body = item.querySelector('.faq__body') as HTMLElement;
    if(!body) return;
    body.style.opacity = '1';
    body.style.height = 'auto';
    body.style.paddingTop = '1.6vw';
  }
  onClose(item: HTMLElement) {
    const body = item.querySelector('.faq__body') as HTMLElement;
    if(!body) return;
    body.style.opacity = '0';
    setTimeout(() => {
    body.style.height = '0px';
    body.style.paddingTop = '0px';
    }, 300);
  }

    init() {
    this.items?.forEach((item) => {
      item.classList.remove('active');
      this.onClose(item);
    });
    this.accordeo?.init();
  }
}

export default function faq(){
  return new Faq();
};